class ConsumersQueryCriteriaController  {
    constructor() {}
}

class ConsumersQueryCriteria{
    constructor(){
        this.require= {
            container: '^consumersContainer'
        };
        this.bindings= {
            query: '<',
        };
        this.controller = ConsumersQueryCriteriaController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumers-query-criteria.html'
    }
}

angular.module('emun.consumer').component('consumersQueryCriteria', new ConsumersQueryCriteria());

export { ConsumersQueryCriteriaController, ConsumersQueryCriteria};